module.exports = __webpack_public_path__ + "media/assets/images/landing/ведомство_11-107c30438c63ad23414617390695f813.png";